/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react'
import { useWindowWidth } from '@packages/util'

import { getLocalStorage, setLocalStorage } from '@lib/simpleFn'
import useExamInform from '@hooks/useExamInform'
import TimerBar from '@components/Timer/TimerBar'
import FiveMinutesAlarmModal from '@components/FiveMinutesAlarmModal'
import TimerImage from '@components/Timer/TimerImage'
import { OFFICIAL_TIME_LIMIT, TUTORIAL_TIME_LIMIT } from '@constant/index'

type TimerProps = {
  showSubmitModal: boolean
  setShowSubmitModal: (trueFalse: boolean) => void
  viewResultMode: boolean
  headerSubmitMode?: boolean
  setTimeout?: (trueFalse: boolean) => void
}

const Timer: React.FC<TimerProps> = ({
  showSubmitModal,
  setShowSubmitModal,
  viewResultMode,
  headerSubmitMode,
  setTimeout,
}) => {
  const { currentGroupId, currentQuestionGroup } = useExamInform()
  const [timeLimit, setTimeLimit] = useState(OFFICIAL_TIME_LIMIT)
  const [seconds, setSeconds] = useState(0)
  const [minutes, setMinutes] = useState(timeLimit)
  const [isTimerOn, setIsTimerOn] = useState(false)

  const [showFiveMinutesAlarmModal, setShowFiveMinutesAlarmModal] = useState(false)

  const windowWidth = useWindowWidth()

  useEffect(() => {
    const timerGroup = getLocalStorage('timerGroup', {})
    const currentTime = new Date()
    const startTestTime = timerGroup[currentGroupId]
      ? new Date(timerGroup[currentGroupId])
      : currentTime
    const diffTime = currentTime.getTime() - startTestTime.getTime()
    const diffMin = Math.ceil(diffTime / (60 * 1000))
    const diffSecond = diffTime ? Math.ceil(59 - (diffTime / 1000 - (diffMin - 1) * 60)) : 0 // diffTime이 0일 경우 diffSecond도 0으로 설정. 설정 안 하면 -1이 됨.
    setMinutes(timeLimit - diffMin)
    setSeconds(diffSecond)
    setIsTimerOn(true)
  }, [timeLimit, currentGroupId])

  useEffect(() => {
    if (!isTimerOn && !showSubmitModal) {
      const timerGroup = getLocalStorage('timerGroup', {})
      if (timerGroup[currentGroupId] == null) {
        // reset timer Todo need to separate lib
        timerGroup[currentGroupId] = new Date()
        setLocalStorage('timerGroup', timerGroup)
      } else {
        setTimeLimit(
          currentQuestionGroup?.type == 'public' ? TUTORIAL_TIME_LIMIT : OFFICIAL_TIME_LIMIT
        )
      }
    }
    if (!viewResultMode) {
      const myInterval = setInterval(() => {
        if (seconds > 0) {
          setSeconds(seconds - 1)
        }
        if (seconds <= 0) {
          if (minutes <= 0) {
            clearInterval(myInterval)
            setShowSubmitModal(true)
            setIsTimerOn(false)
            if (setTimeout) setTimeout(true)
          } else {
            if (minutes === 5) {
              setShowFiveMinutesAlarmModal(true)
            }
            setMinutes(minutes - 1)
            setSeconds(59)
          }
        }
      }, 1000)
      if (minutes < 0) {
        clearInterval(myInterval)
        setShowSubmitModal(true)
        setMinutes(0)
        setSeconds(0)
        setIsTimerOn(false)
      }
      return () => {
        clearInterval(myInterval)
      }
    } else {
      setIsTimerOn(false)
    }
  }, [
    isTimerOn,
    currentGroupId,
    seconds,
    minutes,
    viewResultMode,
    showSubmitModal,
    setShowSubmitModal,
  ])

  const timerImage = useMemo(() => {
    return <TimerImage />
  }, [])

  const timerBarProps = {
    timeLimit,
    minutes,
    seconds,
    windowWidth,
  }

  return (
    <div className={'flex 1.1xl:mx-9 1.1xl:w-[220px] font-medium text-lg'}>
      {timerImage}
      <div className={'ml-2'}>
        <div>제한 시간: {timeLimit}분</div>
        <div className={'relative'}>
          <div className={'relative z-30 pr-1'}>
            남은 시간: {String(minutes).padStart(2, '0')}분 {String(seconds).padStart(2, '0')}초
          </div>
          <TimerBar {...timerBarProps} />
        </div>
      </div>
      {showFiveMinutesAlarmModal && !headerSubmitMode && (
        <FiveMinutesAlarmModal
          show={showFiveMinutesAlarmModal}
          setShow={setShowFiveMinutesAlarmModal}
        />
      )}
    </div>
  )
}

export default Timer
